<template>
  <div>
    <b-row>
      <b-col cols="12" v-if="disableManagement !== true">
        <h4 class="text-primary text-center text-uppercase">
          <i class="fa-solid fa-user"></i>
          {{ $t('tabs.clients.details') }}
        </h4>
      </b-col>
      <b-col cols="4" xl="3">
        <label>{{ $t('columns.id') }}</label>
        <b-form-input :size="small === true ? 'sm' : 'md'" v-model="client.id" readonly/>
      </b-col>
      <b-col cols="4" xl="3">
        <b-form-group
            :invalid-feedback="invalidFirstName"
            :state="stateFirstName"
        >
          <label>{{ $t('columns.firstName') }}</label>
          <b-form-input :size="small === true ? 'sm' : 'md'" v-model="client.firstName" :state="stateFirstName" :readonly="!hasPermission(permissions.CLIENT_UPDATE_CONTACT)"/>
        </b-form-group>
      </b-col>
      <b-col cols="4" xl="3">
        <label>{{ $t('columns.lastName') }}</label>
        <b-form-group
            :invalid-feedback="invalidLastName"
            :state="stateLastName"
        >
        <b-form-input :size="small === true ? 'sm' : 'md'" v-model="client.lastName" :state="stateLastName" :readonly="!hasPermission(permissions.CLIENT_UPDATE_CONTACT)"/>
        </b-form-group>
      </b-col>
      <b-col cols="4" xl="3">
        <b-form-group
            :invalid-feedback="invalidCountry"
            :state="stateCountry"
        >
        <label>{{ $t('columns.country') }}</label>
        <countries-select-box v-bind:small="small" v-model="client.country" :readonly="!hasPermission(permissions.CLIENT_UPDATE_CONTACT)"/>
        </b-form-group>
      </b-col>
      <b-col cols="4" xl="3">
        <label>{{ $t('columns.phone') }}</label>
        <b-input-group>
          <b-form-input :size="small === true ? 'sm' : 'md'" v-if="hasPermission(permissions.CLIENT_READ_PHONE)" v-model="client.phone" :readonly="!hasPermission(permissions.CLIENT_UPDATE_CONTACT)"/>
          <b-form-input :size="small === true ? 'sm' : 'md'" v-else v-model="noAccessData" :readonly="!hasPermission(permissions.CLIENT_UPDATE_CONTACT)" />

          <b-input-group-append>
            <b-button :size="small === true ? 'sm' : 'md'" variant="primary"
                      class="btn btn-outline-primary"
                      :disabled="!hasPhoneToCall('phone') || callInProgress"
                      v-b-tooltip :title="$t('operations.call')"
                      @click="initiateCallClick('phone')"
            >
              <b-spinner small v-if="callInProgress"></b-spinner>
              <i v-else class="fa-solid fa-phone-volume"></i>
            </b-button>
          </b-input-group-append>
        </b-input-group>
      </b-col>
      <b-col cols="4" xl="3">
        <label>{{ $t('columns.mobile') }}</label>
        <b-input-group>
          <b-form-input :size="small === true ? 'sm' : 'md'" v-if="hasPermission(permissions.CLIENT_READ_PHONE)" v-model="client.mobile" :readonly="!hasPermission(permissions.CLIENT_UPDATE_CONTACT)"/>
          <b-form-input :size="small === true ? 'sm' : 'md'" v-else v-model="noAccessData" :readonly="!hasPermission(permissions.CLIENT_UPDATE_CONTACT)" />

          <b-input-group-append>
            <b-button :size="small === true ? 'sm' : 'md'" variant="primary"
                      class="btn btn-outline-primary"
                      :disabled="!hasPhoneToCall('mobile') || callInProgress"
                      v-b-tooltip :title="$t('operations.call')"
                      @click="initiateCallClick('mobile')"
            >
              <b-spinner small v-if="callInProgress"></b-spinner>
              <i v-else class="fa-solid fa-phone-volume"></i>
            </b-button>
          </b-input-group-append>
        </b-input-group>
      </b-col>
      <b-col cols="4" xl="3">
        <label>{{ $t('columns.email') }}</label>
        <b-form-group
            :invalid-feedback="invalidEmail"
            :state="stateEmail"
        >
          <b-input-group>
          <b-form-input :size="small === true ? 'sm' : 'md'" v-if="hasPermission(permissions.CLIENT_READ_EMAIL)" v-model="client.email" :state="stateEmail" :readonly="!hasPermission(permissions.CLIENT_UPDATE_CONTACT)"/>
          <b-form-input :size="small === true ? 'sm' : 'md'" v-else v-model="noAccessData" :readonly="!hasPermission(permissions.CLIENT_UPDATE_CONTACT)" />
          <b-input-group-append>
            <b-button :size="small === true ? 'sm' : 'md'" variant="outline-primary" @click="gotToChat">
              <i class="fa-solid fa-comment"></i>
            </b-button>
            <b-button :size="small === true ? 'sm' : 'md'" variant="primary" @click="openEmailEditor" v-b-tooltip :title="$t('operations.sendMail')">
              <i class="fa-solid fa-envelope"></i>
            </b-button>
          </b-input-group-append>
        </b-input-group>
        </b-form-group>
      </b-col>
      <b-col cols="4" xl="3">
        <label>{{ $t('columns.email2') }}</label>
        <b-form-input :size="small === true ? 'sm' : 'md'" v-if="hasPermission(permissions.CLIENT_READ_EMAIL)" v-model="client.email2" :readonly="!hasPermission(permissions.CLIENT_UPDATE_CONTACT)"/>
        <b-form-input :size="small === true ? 'sm' : 'md'" v-else v-model="noAccessData" :readonly="!hasPermission(permissions.CLIENT_UPDATE_CONTACT)" />

      </b-col>
      <b-col cols="4" xl="3">
        <label>{{ $t('columns.address') }}</label>
        <b-form-input :size="small === true ? 'sm' : 'md'" v-model="client.address" :readonly="!hasPermission(permissions.CLIENT_UPDATE_CONTACT)"/>
      </b-col>
      <b-col cols="4" xl="3">
        <label>{{ $t('columns.zip') }}</label>
        <b-form-input :size="small === true ? 'sm' : 'md'" v-model="client.zip" :readonly="!hasPermission(permissions.CLIENT_UPDATE_CONTACT)"/>
      </b-col>
      <b-col cols="4" xl="3">
        <label>{{ $t('columns.city') }}</label>
        <b-form-input :size="small === true ? 'sm' : 'md'" v-model="client.city" :readonly="!hasPermission(permissions.CLIENT_UPDATE_CONTACT)"/>
      </b-col>
      <b-col cols="4" xl="3">
        <label>{{ $t('columns.birthday') }}</label>
        <b-form-datepicker
            :size="small === true ? 'sm' : 'md'"
            v-model="client.birthday"
            :disabled="!hasPermission(permissions.CLIENT_UPDATE_CONTACT)"
            :value-as-date="false"
            date-format="yyyy-MM-dd"
            placeholder="YYYY-MM-DD"
            today-button
            close-button
            class="w-100"
            :show-decade-nav="true"
        :date-info-fn="null"
        />
      </b-col>

      <b-col cols="4" xl="3">
        <label>{{ $t('columns.gender') }}</label>
        <b-form-input :size="small === true ? 'sm' : 'md'" v-model="client.gender" :readonly="!hasPermission(permissions.CLIENT_UPDATE_CONTACT)"/>
      </b-col>


      <b-col cols="4" xl="3">
        <label>{{ $t('columns.password') }}</label>
        <b-input-group>
          <b-form-input :size="small === true ? 'sm' : 'md'" v-model="client.password" :readonly="!hasPermission(permissions.CLIENT_UPDATE_CONTACT)"/>
          <b-input-group-append>
            <b-button-group>
              <b-button :size="small === true ? 'sm' : 'md'" class="border-bottom" variant="outline-primary" @click="generatePassword" v-b-tooltip title="Generate Password">
                <i class="fa-solid fa-key"></i>
              </b-button>
              <b-dropdown :size="small === true ? 'sm' : 'md'" variant="primary">
                <template #button-content>
                  <i class="fa-solid fa-envelope"></i>
                </template>
                <b-dropdown-item @click="passwordEvent(false)">Update</b-dropdown-item>
                <b-dropdown-item @click="passwordEvent(true)">Update and Send Email</b-dropdown-item>
              </b-dropdown>
            </b-button-group>
          </b-input-group-append>
        </b-input-group>
      </b-col>

      <!-- STATUS (ALWAYS VISIBLE) -->
      <b-col cols="4" xl="3" v-if="disableManagement === true">
        <label>{{ $t('columns.statusId') }}</label>
        <client-status-picker small
            v-model="client.statusId"
            :readonly="!hasPermission(permissions.CLIENT_UPDATE_CONTACT)"
        />
      </b-col>


    </b-row>
    <!-- Management Section -->
    <b-row class="mt-4 client-management" v-if="disableManagement !== true">
      <b-col cols="12">
        <h4 class="text-primary text-center text-uppercase">
          <i class="fa-solid fa-building-circle-exclamation"></i>
          {{ $t('tabs.clients.management') }}
        </h4>
      </b-col>
      <b-col cols="4" xl="3">
        <label>{{ $t('columns.creationTime') }}</label>
        <date-time-picker size="md" v-model="client.creationTime" disabled/>
      </b-col>
      <b-col cols="4" xl="3">
        <label>{{ $t('columns.ftdTime') }}</label>
        <date-time-picker size="md" v-model="client.ftdTime" disabled/>
      </b-col>
      <b-col cols="4" xl="3" v-if="hasManyBusinessUnits">
        <label>{{ $t('columns.businessUnitId') }}</label>
        <business-unit-select-box v-model="client.businessUnitId"
                                  :disabled="!hasPermission(permissions.CLIENT_UPDATE_BU)"
        />
      </b-col>
      <b-col cols="4" xl="3" v-if="hasManyOrganizations">
        <label>{{ $t('columns.orgId') }}</label>
        <organization-select-box v-model="client.orgId" :disabled="!hasPermission(permissions.CLIENT_UPDATE_ORG)" readonly/>
      </b-col>
      <b-col cols="4" xl="3" >
        <label>{{ $t('columns.statusId') }}</label>
        <client-status-picker v-model="client.statusId" :readonly="!hasPermission(permissions.CLIENT_UPDATE_CONTACT)"/>
      </b-col>
      <b-col cols="4" xl="3">
        <label>{{ $t('columns.presaleUserId') }}</label>
        <user-picker v-model="client.presaleUserId" :disabled="!hasPermission(permissions.CLIENT_UPDATE_REPRESENTATIVE)"/>
      </b-col>
      <b-col cols="4" xl="3">
        <label>{{ $t('columns.representativeUserId') }}</label>
        <user-picker v-model="client.representativeUserId" :disabled="!hasPermission(permissions.CLIENT_UPDATE_REPRESENTATIVE)"/>
      </b-col>
      <b-col cols="4" xl="3">
        <label>{{ $t('columns.retentionUserId') }}</label>
        <user-picker v-model="client.retentionUserId" :disabled="!hasPermission(permissions.CLIENT_UPDATE_REPRESENTATIVE)"/>
      </b-col>
    </b-row>
    <b-row class="mt-5 client-affiliate-management" v-if="disableManagement !== true && hasPermission(permissions.CLIENT_READ_AFFILIATE)">
      <b-col cols="12">
        <h4 class="text-primary text-center text-uppercase">
          <i class="fa-solid fa-person-shelter"></i>
          {{ $t('tabs.clients.affiliate') }}
        </h4>
      </b-col>
      <b-col cols="4" xl="3">
        <label>{{ $t('columns.affiliateId') }}</label>
        <affiliate-select-box v-model="client.affiliateId"/>
      </b-col>

      <b-col cols="4" xl="3">
        <label>{{ $t('columns.campaign') }}</label>
        <b-form-input :size="small === true ? 'sm' : 'md'" v-model="client.campaign"/>
      </b-col>
      <b-col cols="4" xl="3">
        <label>{{ $t('columns.banner') }}</label>
        <b-form-input :size="small === true ? 'sm' : 'md'" v-model="client.banner"/>
      </b-col>
      <b-col cols="4" xl="3">
        <label>{{ $t('columns.tag') }}</label>
        <b-form-input :size="small === true ? 'sm' : 'md'" v-model="client.tag"/>
      </b-col>
    </b-row>
    <!-- Notes and Events Section -->
    <b-row class="mt-5" v-if="hasPermission(permissions.CLIENT_READ)">
      <b-col cols="6">
        <b-row>
          <b-col cols="12" title="test">
            <client-events ref="events" v-bind:client-id="client.id" autoload/>
          </b-col>
        </b-row>
      </b-col>


      <b-col cols="6">
        <b-row class="justify-content-end">
          <b-col cols="12">
            <client-notes ref="notes" v-bind:client-id="client.id" autoload/>
          </b-col>
        </b-row>
      </b-col>

    </b-row>

    <div class="text-center mt-2">
      <slot name="button" :update="update">
        <b-button :size="small === true ? 'sm' : 'md'" block  variant="primary" @click="update">{{$t('operations.save')}}</b-button>
      </slot>
    </div>

    <email-editor-modal @emailTemplateSaved="sendEmail" ref="emailEditorModal" :receiver="client"></email-editor-modal>

    <!-- Call confirmation modal -->
    <b-modal v-model="showCallConfirmModal" :title="$t('click2call.confirmTitle')" @ok="confirmCall" :ok-title="$t('click2call.initiate')" :cancel-title="$t('operations.cancel')">
      <p>{{ $t('click2call.confirmMessage', { number: pendingCallPhone }) }}</p>
    </b-modal>
  </div>
</template>

<script>
import Client from '@/model/client/Client';
import mixinPermissions from '@/components/mixin/mixinPermissions';
import { mapActions } from 'vuex';
import mixinNotifications from '@/components/mixin/mixinNotifications';
import OrganizationSelectBox from '@/components/widget/select/OrganizationSelectBox';
import BusinessUnitSelectBox from '@/components/widget/select/BusinessUnitSelectBox';
import CountriesSelectBox from '@/components/widget/select/CountriesSelectBox';
import mixinBase from '@/components/mixin/mixinBase';
import UserPicker from '@/components/widget/picker/userPicker';
import ClientStatusPicker from '@/components/widget/picker/clientStatusPicker';
import EmailEditorModal from '@/components/partial/mailTemplates/EmailEditorModal';
import ClientNotes from '@/components/partial/notes/notes';
import ClientEvents from '@/components/partial/notes/events';
import AffiliateSelectBox from '@/components/widget/select/AffiliateSelectBox.vue';
import DateTimePicker from '@/components/widget/picker/dateTimePicker.vue'

export default {
  name: 'ClientEditDetails',
  components: {
    DateTimePicker,
    ClientNotes,
    ClientEvents,
    UserPicker,
    EmailEditorModal,
    CountriesSelectBox,
    BusinessUnitSelectBox,
    OrganizationSelectBox,
    AffiliateSelectBox,
    ClientStatusPicker
  },
  mixins: [mixinBase, mixinPermissions, mixinNotifications],
  data: () => ({
    client: Client(),
    noAccessData: 'xxxxxx',
    sendEmailPassword: false,
    mandatoryFieldState: {"stateFirstName": false, "stateLastName": false,
      "stateEmail": false, "stateCountry": false},
    showCallConfirmModal: false,
    pendingCallPhone: '',
    callInProgress: false
  }),
  props: {
    value: {
      required: true,
      default: () => ({})
    },
    disableManagement: {
      type: Boolean,
      default: false
    },
    small:{
      type: Boolean,
      default: false
    }
  },
  watch: {
    value: {
      handler() {
        console.log("doing handler again...")
        this.client = Object.assign(Client(), this.value);
      },
      immediate: true
    }
  },
  computed: {
    stateFirstName() {
      if (this.client === null || this.client.firstName === null || this.client.firstName.length < 1) {
        this.mandatoryFieldState.stateFirstName = false;
        return false;
      } else {
        this.mandatoryFieldState.stateFirstName = true
        return null;
      }
    },
    stateLastName() {
      if (this.client === null || this.client.lastName === null || this.client.lastName.length < 1) {
        this.mandatoryFieldState.stateLastName = false;
        return false;
      } else {
        this.mandatoryFieldState.stateLastName = true
        return null;
      }
    },
    stateEmail() {

      if (this.client === null || this.client.email === null ||
          !(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(this.client.email))) {
        this.mandatoryFieldState.stateEmail = false;
        return false;
      } else {
        this.mandatoryFieldState.stateEmail = true;
        return null;
      }
    },
    stateCountry() {
      if (this.client === null || this.client.country === null || this.client.country.length < 1) {
        this.mandatoryFieldState.stateCountry = false;
        return false;
      } else {
        this.mandatoryFieldState.stateCountry = true
        return null;
      }
    },
    invalidFirstName() {
      if (this.client.firstName && this.client.firstName.length > 0) {
        return 'Enter at least 1 characters.'
      }
      return 'Please enter something.'
    },

    invalidLastName() {
      if (this.client.lastName && this.client.lastName.length > 0) {
        return 'Enter at least 1 characters.'
      }
      return 'Please enter something.'
    },

    invalidEmail() {
      if (this.client.email && this.client.email.length > 0) {
        return 'Enter at least 1 characters.'
      }
      return 'Please enter something.'
    },

    invalidCountry() {
      if (this.client.country && this.client.country.length > 0) {
        return 'Enter at least 1 characters.'
      }
      return 'Please enter something.'
    }
  },
  methods: {
    ...mapActions('clients', ['updateClient', 'handlePasswordEvent', 'click2call']),

    hasPhoneToCall(field) {
      if (!this.hasPermission(this.permissions.CLIENT_READ_PHONE)) return false;
      const phone = field === 'phone' ? this.client.phone : this.client.mobile;
      return phone && String(phone).trim().length >= 6;
    },
    initiateCallClick(field) {
      const phone = field === 'phone' ? this.client.phone : this.client.mobile;
      if (!phone || !this.hasPhoneToCall(field)) return;
      this.pendingCallPhone = phone;
      this.pendingCallField = field;
      this.showCallConfirmModal = true;
    },
    confirmCall() {
      const phone = this.pendingCallPhone;
      this.showCallConfirmModal = false;
      this.callInProgress = true;
      const $this = this;
      this.click2call({ phoneNumber: phone, clientId: this.client.id })
        .then(() => {
          $this.showSuccessNotification($this.$t('click2call.success'));
          $this.pendingCallPhone = '';
        })
        .catch((err) => {
          $this.showErrorNotification($this.$t('click2call.error'), $this.getErrorDescription ? $this.getErrorDescription(err) : (err?.error || err?.message || String(err)));
        })
        .finally(() => {
          $this.callInProgress = false;
        });
    },
    openEmailEditor() {
      // Show the email editor modal
      this.$refs.emailEditorModal.showModal = true;
    },
    gotToChat(){
      this.$router.push({ path: '/clients/chat', query: { sessionClientId: this.client.id } })
      this.$emit('close');
    },
    sendEmail() {
      this.$refs.emailEditorModal.showModal = false;
    },
    generatePassword() {
      const length = 10; // Length of the generated password
      const charset = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789'; // Characters to include in the password
      let newPassword = '';
      for (let i = 0; i < length; i++) {
        newPassword += charset.charAt(Math.floor(Math.random() * charset.length));
      }
      this.client.password = newPassword; // Set the generated password to client.password
    },
    passwordEvent(sendMail) {
      let $this = this
      this.handlePasswordEvent({ clientId: this.client.id, sendMail: sendMail, password: this.client.password })
          .then((client) => {
            if(sendMail) {
              this.showSuccessNotification($this.$t('globalMessages.emailSentSuccessfully', { system: $this.$t('passwordSent') }))
            }else {
              this.showSuccessNotification($this.$t('globalMessages.updateDataSuccess', { system: $this.$t('menu.clients') }))
            }
          }, (err) => {
            $this.showErrorNotification($this.$t('globalMessages.emailSentError', { system: $this.$t('passwordSent') }), err.error + ' ' + err.params)
          })
    },

    update() {
      let neededField = this.checkMandatory();
      if (!neededField)
        return;
      let $this = this;
      if (this.client.birthday) {
        // If it's a Date object → convert to YYYY-MM-DD
        const date = new Date(this.client.birthday);
        this.client.birthday = date.toISOString().split('T')[0];
      }
      return this.updateClient({
        client: this.client,
        id: this.client.id
      }).then(
          () => {
            this.showSuccessNotification($this.$t('globalMessages.updateDataSuccess', { system: $this.$t('menu.clients') }));
            this.refreshTables();
            $this.$emit('input', this.client);
          }
      ).catch(err => {
            $this.showErrorNotification($this.$t('globalMessages.fetchDataError', { system: $this.$t('menu.clients') }), err.error + ' ' + err.params);
          });
    },
    checkMandatory(){
      for(let key in this.mandatoryFieldState){
        if (this.mandatoryFieldState[key]=== false) {
          console.log("state is false")
          return false;
        }
      }
      console.log("state is true")
      return true;
    },
  }
};
</script>

<style scoped>

</style>
